import { Alert as AlertMantine } from '@mantine/core'
import React from 'react'

import { ReactComponent as InfoIcon } from '../../../icones/infoAmarelo.svg'
import { useGlobal } from '../../../stores/useGlobal'

import * as S from './styles'

const types = {
  default: {},
  warning: {
    icon: <InfoIcon alt="info" src={InfoIcon} />
  }
}

const DEFAULT_ALERT = {
  show: false,
  type: 'default',
  title: '',
  message: ''
}

export default function Alert() {
  const { mostrarAlerta, setMostrarAlerta } = useGlobal()

  const { type, title, message } = mostrarAlerta

  const alertProps = types[type]

  if (!mostrarAlerta.show) return null

  const handleClose = () => setMostrarAlerta(DEFAULT_ALERT)

  return (
    <S.AlertWrapper>
      <AlertMantine
        radius="sm"
        title={title}
        color="yellow"
        withCloseButton
        onClose={handleClose}
        {...alertProps}
      >
        {message}
      </AlertMantine>
    </S.AlertWrapper>
  )
}
